import React from "react";
import { useLocation } from "react-router-dom";
// import components
import BreadcrumbHead from "../../../../Components/BreadcrumbHead/BreadcrumbHead";
import Footer from "../../../../Components/Footer/Footer";
import Navbar from "../../../../Components/Navbar/Navbar";
import Introduction from "../Components/Introduction";

const descriptions = [
  "We proudly present Dukandar Online, a transformative platform dedicated to empowering small and medium-sized enterprises (SMEs) with comprehensive digital solutions. In collaboration with Dukandar Online, our team has developed an integrated system that offers automated inventory control, online POS, customer and ledger management, data analytics, business intelligence, location-based promotions, contactless payments, and quick delivery services. Together, we've revolutionized how SMEs operate, driving efficiency and growth through cutting-edge technology. ",
];

function DukandarOnlineProjectDetail() {
  const location = useLocation();
  const { state: project } = location;
  return (
    <>
      <Navbar />
      <BreadcrumbHead title={"Dukandar Online"} />
      <Introduction
        src={project.imagePath}
        linkUrl={project.linkUrl}
        appStoreUrl={project.appStoreUrl}
        googlePlayUrl={project.googlePlayUrl}
        descriptions={descriptions}
      />
      <Footer />
    </>
  );
}

export default DukandarOnlineProjectDetail;
